export const routes = {
    "/:taskId/genericCaseClinicalNotes": {
        title: "Clinical Notes"
    }
};
